import React, { useEffect, useState } from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  newsletterPageStructuredData,
  newsletterPageAdditionalMeta,
} from '../../utils/data/MetaData';
// Components
import NewsletterSignUpPageMainContainer from '../../components/newsletter/NewsletterSignUpPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import Navbar from '../../components/nav/Navbar';
import PageDivider from '../../components/gallery/PageDivider';
import GeneralHeader from '../../components/header/GeneralHeader';

function NewsletterSignUpPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-newsletter');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Newsletter Sign-Up'
        desc={`Stay updated with the latest from ${CompanyName}. Subscribe to our newsletter for news, updates, and special offers on web and circuit design services.`}
        keywords={`newsletter, subscribe, updates, web design news, circuit design news, ${CompanyName}, email sign-up`}
        additionalMeta={newsletterPageAdditionalMeta}
        structuredData={newsletterPageStructuredData}
      />

      <div className='grid grid-rows-reg min-h-screen font-main bg-colour1 dark:bg-colour1 text-colour2 dark:text-colour2 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-newsletter'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />

          {/* Divider */}
          <PageDivider />

          {/* Header */}
          <GeneralHeader
            page={`Newsletter`}
            title={`Stay up to date with Miss Dominatrixa!`}
          />
        </div>

        {/* Main */}
        <NewsletterSignUpPageMainContainer />
      </div>
    </>
  );
}

export default NewsletterSignUpPage;
